/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object";

export default ($axios: any) => ({
  async deleteImage(data?: any) {
    return camelize(
      await $axios.delete(`/sns/user/image`, snakelize({ data: data }))
    );
  },
});
